import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { User } from '../../types/schema';
import { setLoading } from '../../store/appSlice';


interface ResetPasswordModalProps {
  open: boolean;
  onClose: () => void;
  onConfirmReset: (password: string) => void;
  user: User | null;
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

const ResetPasswordModal: React.FC<ResetPasswordModalProps> = ({ open, onClose, onConfirmReset, user }) => {
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    dispatch(setLoading(true));
    try {
      await onConfirmReset(password);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2">
          Reset Password for {user?.full_name}
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          label="New Temporary Password"
          type="password"
          fullWidth
          variant="standard"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" sx={{ ml: 1 }}>Reset</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ResetPasswordModal;
